import { Link, NavLink } from "react-router-dom";
import { Radio, Menu, X } from "lucide-react";
import { useState } from "react";

const navItems = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/events", label: "Events", testid: "nav-events" },
  { to: "/my-reservations", label: "My Tickets", testid: "nav-reservations" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 backdrop-blur-2xl bg-[#0A0A0A]/70 border-b border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="logo-link"
          className="flex items-center gap-2 group"
        >
          <span className="relative inline-flex items-center justify-center w-8 h-8 bg-[#B4FF39]">
            <Radio className="w-4 h-4 text-[#0A0A0A]" strokeWidth={2.5} />
          </span>
          <span className="font-display text-xl tracking-tighter">
            365<span className="text-[#B4FF39]">LIVE</span>
          </span>
          <span className="hidden sm:inline-flex items-center gap-1.5 ml-3 text-[10px] tracking-[0.2em] uppercase text-zinc-400">
            <span className="w-1.5 h-1.5 bg-[#B4FF39] live-dot" />
            On Air
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={item.testid}
              end={item.to === "/"}
              className={({ isActive }) =>
                `text-sm tracking-[0.12em] uppercase font-medium link-underline transition-colors ${
                  isActive ? "text-white" : "text-zinc-400 hover:text-white"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/events"
            data-testid="header-browse-cta"
            className="bg-[#B4FF39] text-[#0A0A0A] font-bold px-5 py-2.5 hover:bg-[#9FE822] transition-colors uppercase tracking-[0.12em] text-xs"
          >
            Browse Live
          </Link>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden text-white"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden border-t border-white/5 bg-[#0A0A0A]">
          <div className="px-6 py-6 flex flex-col gap-4">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-${item.testid}`}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `text-base tracking-[0.12em] uppercase font-medium ${
                    isActive ? "text-[#B4FF39]" : "text-zinc-300"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
